<template>
    <div>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("pedidosAProveedor")}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="listBusiness"><strong>{{$t("negocio")}}</strong></label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           @change="getProveedores(),idSupplier=0,listProveedores=[]"
                                           :placeholder="this.$i18n.t('seleccionaNegocio')">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>


                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="listProveedor"><strong>{{$t("proveedores")}}</strong></label>

                                <el-select class="select-default"
                                           size="large"
                                           @change="getPedidosNegocio()"
                                           v-model="idSupplier"
                                           filterable
                                           :placeholder="this.$i18n.t('seleccioneUnProveedor')">
                                    <el-option v-for="su in listProveedores"
                                               class="select-primary"
                                               :value="su.id"
                                               :label="su.name"
                                               :key="su.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>


                        <div class="col-md-2">
                            <div class="form-group">
                                <label><strong>{{$t("fechaInicio")}}</strong></label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        format="dd-MM-yyyy"
                                        :title="this.$i18n.t('fechaInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="datefrom"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label><strong>{{$t("fechaFin")}}</strong></label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        :title="this.$i18n.t('fechaFin')"
                                        format="dd-MM-yyyy"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="dateto"></datetime>
                            </div>
                        </div>


                        <div class="col-md-2">
                            <label>&nbsp;</label>
                            <div class="form-group">
                                <button @click="getPedidosNegocio()" class="btn btn-primary">
                                    <img src="static/img/sync.gif" alt="" v-if="loading" width="15">
                                    {{$t("consultar")}}
                                </button>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <label><strong>{{$t("tipo")}}</strong></label>
                            <div class="form-group">
                                <el-radio v-model="tipo" :label='0' @change="getPedidosNegocio()">{{$t("todos")}}
                                </el-radio>
                                <el-radio v-model="tipo" :label='1' @change="getPedidosNegocio()">{{$t("pedidos")}}
                                </el-radio>
                                <el-radio v-model="tipo" :label='2' @change="getPedidosNegocio()">
                                    {{$t("pedidosConvertidos")}}
                                </el-radio>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <div class="col-md-12" v-else-if="respuesta">
                <div class="card">
                    <template>
                        <div class="row">
                            <div class="col-md-12 text-left">
                                <div class="form-group">
                                    <router-link :to="{name:'pedido-proveedor', params:{'idBusiness':this.idBusiness}}">
                                        <button class="btn btn-primary"><i class="fa fa-plus-square"></i>
                                            {{$t("nuevoPedido")}}
                                        </button>
                                    </router-link>

                                    <el-badge :value="listEnviarCorreo.length" class="item"
                                              v-if="listEnviarCorreo.length>0">
                                        <button @click="openModalEnviarCorreo()" class="btn btn-xs"><i
                                                class="fa fa-envelope"></i>
                                            {{$t("enviarPedidos")}}
                                        </button>
                                    </el-badge>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <div v-if="list.length>0" class="table-responsive">
                                    <table class="table table-bordered table-striped">
                                        <thead class="thead-dark">
                                        <tr>
                                            <th>
                                                <span v-if="ordenarFecha"
                                                      @click="sortedArrayASC(1),ordenarFecha=0"><i
                                                        style="color: white" class="fa fa-angle-up"></i> {{$t("fecha")}}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(1), ordenarFecha=1"><i
                                                        style="color: white" class="fa fa-angle-down"></i> {{$t("fecha")}}
                                                </span>
                                            </th>

                                            <th>
                                                <span v-if="ordenarProveedor"
                                                      @click="sortedArrayASC(2),ordenarProveedor=0"><i
                                                        style="color: white" class="fa fa-angle-up"></i> {{$t("proveedor")}}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(2), ordenarProveedor=1"><i
                                                        style="color: white" class="fa fa-angle-down"></i> {{$t("proveedor")}}
                                                </span>
                                            </th>

                                            <th>
                                                <span v-if="ordenarImporte"
                                                      @click="sortedArrayASC(3),ordenarImporte=0"><i
                                                        style="color: white" class="fa fa-angle-up"></i> {{$t("importe")}}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(3), ordenarImporte=1"><i
                                                        style="color: white" class="fa fa-angle-down"></i> {{$t("importe")}}
                                                </span>
                                            </th>

                                            <th>
                                                <span v-if="ordenarBase"
                                                      @click="sortedArrayASC(4), ordenarBase=0"><i
                                                        style="color: white" class="fa fa-angle-up"></i> {{$t("base")}}
                                                </span>
                                                <span v-else @click="sortedArrayDESC(4), ordenarBase=1"><i
                                                        style="color: white" class="fa fa-angle-down"></i> {{$t("base")}}
                                                </span>
                                            </th>

                                            <th>{{$t("detalles")}}</th>
                                            <th>{{$t("convertido")}}</th>
                                            <th>{{$t("emailenviado")}}</th>
                                            <th>{{$t("acciones")}}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(obj,index) in list">
                                            <td>
                                                <div>{{obj.date | parseDate}}</div>
                                            </td>
                                            <td>
                                                <div>{{obj.supplierName}}</div>
                                            </td>
                                            <td align="right">
                                                <div>{{obj.total | currency}}</div>
                                            </td>
                                            <td align="right">
                                                <div>{{obj.totalBase | currency}}</div>
                                            </td>
                                            <td align="center">
                                                <div>
                                                    <router-link
                                                            :to="{name:'pedido-proveedor',params:{'idBusiness':idBusiness,'idPedido':obj.id,'editar':0}}">
                                                        <button class="btn btn-secondary"
                                                                v-tooltip.top-center="$i18n.t('detallesDelPedido')">
                                                            <i class="fas fa-tags"></i> {{$t("ver")}}
                                                        </button>
                                                    </router-link>
                                                </div>
                                            </td>
                                            <td>
                                                <div> 
                                                    <span v-if="!obj.converted">
                                                        <i class="fas fa-times text-danger"></i> {{$t("no")}}
                                                    </span>
                                                    <span v-else>
                                                        <i class="fas fa-check text-success"></i> {{$t("si")}}
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <div> 
                                                    <span v-if="!obj.emailEnviado">
                                                        <i class="fas fa-times text-danger"></i> {{$t("no")}}
                                                    </span>
                                                    <span v-else>
                                                        <i class="fas fa-check text-success"></i> {{$t("si")}}
                                                    </span>
                                                </div>
                                            </td>
                                            <td width="5%">
                                                <div>
                                                    <el-dropdown>
                                                        <el-button type="secondary" size="medium">
                                                            <i class="fas fa-cog"></i>
                                                            {{$t("acciones")}} <i
                                                                class="el-icon-arrow-down el-icon--right"></i>
                                                        </el-button>
                                                        <el-dropdown-menu slot="dropdown">
                                                            <p v-if="!obj.converted"
                                                               @click="modalConvertirGasto(index)">
                                                                <i class="fas fa-check text-success"></i>
                                                                {{$t("convertirEnGasto")}}
                                                            </p>
                                                            <p v-if="!obj.converted" @click="modificarPedido(obj)">
                                                                <i class="fas fa-cog text-warning"></i>
                                                                {{$t("modificar")}}
                                                            </p>
                                                            <p v-if="!obj.converted" @click="modaleliminar(obj)">
                                                                <i class="fas fa-minus-circle text-danger"></i>
                                                                {{$t("eliminar")}}
                                                            </p>
                                                            <a :href="urlExportPDFConPrecio(obj.id)">
                                                                <p class="text-danger"><strong><i
                                                                        class="fa fa-file-pdf"></i>
                                                                    {{$t("descargarComoPDF")}}</strong>
                                                                </p>
                                                            </a>
                                                            <a :href="urlExportPDFSinPrecio(obj.id)">
                                                                <p class="text-danger"><strong><i
                                                                        class="fa fa-file-pdf"></i>
                                                                    {{$t("descargarComoPDFSinPrecios")}}</strong>
                                                                </p>
                                                            </a>
                                                            <a :href="urlExportExcelConPrecio(obj.id)">
                                                                <p class="text-success"><strong><i
                                                                        class="fa fa-file-excel"></i>
                                                                    {{$t("descargarComoExcel")}}</strong>
                                                                </p>
                                                            </a>
                                                            <a :href="urlExportExcelSinPrecio(obj.id)">
                                                                <p class="text-success"><strong><i
                                                                        class="fa fa-file-excel"></i>
                                                                    {{$t("descargarComoExcelSinPrecios")}}</strong></p>
                                                            </a>
                                                            <p class="text-primary"
                                                               @click="agregarListaCorreo(obj); openModalEnviarCorreo()">
                                                                <strong><i class="fas fa-envelope"></i>
                                                                    {{$t("enviarPorCorreo")}}</strong></p>

                                                            <p v-if="obj.enviarCorreo"
                                                               @click="eliminarListaCorreo(obj,index)"><i
                                                                    class="far fa-folder-open text-danger"></i>
                                                                {{$t("eliminarListaCorreo")}} </p>

                                                            <p v-else @click="agregarListaCorreo(obj)"><i
                                                                    class="far fa-folder-open"></i>
                                                                {{$t("anyadirListaCorreo")}}
                                                            </p>
                                                        </el-dropdown-menu>
                                                    </el-dropdown>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                        <tfoot>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-if="!list.length>0">
                        <div class="alert alert-danger" role="alert">
                            {{$t("noHayPedidosAEsteProveedorEnEsteRangoDeFecha")}}
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <modal name="modal-enviar-correo" :adaptive=true :scrollable=true height="auto" :clickToClose=false>
            <div>
                <div class="modal-header">
                    <h3 style="margin: 0px">{{$t("enviarPedido")}}</h3>
                </div>
                <div class="modal-body">

                    <table class="table table-bordered table-striped">
                        <thead class="thead-dark">
                        <tr>
                            <th>{{$t("fecha")}}</th>
                            <th>{{$t("negocio")}}</th>
                            <th>{{$t("proveedor")}}</th>
                            <th>{{$t("total")}}</th>
                            <th>{{$t("base")}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="d in listEnviarCorreo">
                            <td>
                                <div>{{d.date | parseDate}}</div>
                            </td>
                            <td>
                                <div>{{d.establishmentName}}</div>
                            </td>
                            <td>
                                <div>{{d.supplierName}}</div>
                            </td>
                            <td>
                                <div>{{d.total | currency}}</div>
                            </td>
                            <td>
                                <div>{{d.totalBase | currency}}</div>
                            </td>
                        </tr>
                        </tbody>
                        <tfoot>
                        </tfoot>
                    </table>

                    <div class="form-group">
                        <label><strong>{{$t("enviarPedidoA")}}:</strong></label>
                        <input v-model="emailSupplier" class="form-control" type="text"/>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <label><strong>{{$t("formato")}}</strong></label>
                            <div class="form-group">
                                <el-radio v-model="tipo" label='PDF'>{{$t("PDF")}}
                                </el-radio>
                                <el-radio v-model="tipo" label='Excel'>{{$t("excel")}}
                                </el-radio>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label><strong>{{$t("tipo")}}</strong></label>
                            <div class="form-group">
                                <el-radio v-model="precio" label='1'>{{$t("conPrecios")}}
                                </el-radio>
                                <el-radio v-model="precio" label='0'>{{$t("sinPrecios")}}
                                </el-radio>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button @click="closeModal()" class="btn btn-default"><i
                            class="fa fa-times-circle"></i> {{$t("cancelar")}}
                    </button>
                    <button class="btn btn-primary" v-once-click.once="enviarEmail"><i class="fa fa-check-circle"></i>
                        {{$t("aceptar")}}
                    </button>
                </div>
            </div>
        </modal>

        <modal name="modal-convertir-gasto" :adaptive=true :scrollable=true height="auto" :clickToClose=false>
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">{{$t("convertirPedido")}}</h4>
                </div>
                <div class="modal-body">

                    <label><strong>{{$t("tipoDeDocumento")}}</strong></label>
                    <div class="form-group">
                        <el-radio v-model="tipoDocumento" label='F'>{{$t("factura")}}
                        </el-radio>
                        <el-radio v-model="tipoDocumento" label='A'>{{$t("albaran")}}
                        </el-radio>
                    </div>

                    <div class="form-group">
                        <label><strong>{{$t("referencia")}}</strong></label>
                        <input v-model="ref" class="form-control" type="text"/>
                    </div>

                    <div class="form-group">
                        <input type="checkbox" id="generarEntrada" v-model="includedWarehouse">
                        <label class="checkGenerarEntrada" for="generarEntrada">{{$t("generarEntradaEnAlmacenAlVerificar")}}</label>
                    </div>

                </div>
                <div class="modal-footer">
                    <button @click="closeModal()" class="btn btn-default"><i
                            class="fa fa-times-circle"></i> {{$t("cancelar")}}
                    </button>
                    <button class="btn btn-primary" @click="convertirGasto()" :disabled="loadingConvertir"><i class="fa fa-check-circle"></i>
                        {{loadingConvertir ? $t("procesando") : $t("aceptar")}}
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    //import Chart from '../../../../node_modules/chart.js/src/chart';
    import {
        DatePicker,
        Select,
        Option,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        Button,
        Radio,
        Checkbox,
        Badge
    } from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'
    import { mapState } from 'vuex'

    export default {
        created() {
            this.$store.dispatch("setNameRoute",  this.$i18n.t("pedidosAProveedor"));
            this.getBusiness();

            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {

                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;

            }
        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [Radio.name]: Radio,
            [Checkbox.name]: Checkbox,
            [Badge.name]: Badge
        },
        data() {
            return {
                loading: false,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                listBusinesses: [],
                listBusinessesemail: [],
                idBusiness: 0,
                value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
                list: ["-"],
                idSupplier: 0,
                listProveedores: [],
                tipo: 0,
                emailSupplier: "",
                tipoDocumento: 'F',
                precio: "1",
                includedWarehouse: true,
                ref: '',
                indice: 0,
                listEnviarCorreo: [],
                loadingConvertir: false,

                //ORDENAR
                ordenarFecha: 0,
                ordenarProveedor: 0,
                ordenarImporte: 0,
                ordenarBase: 0,
                ordenarDetalles: 0,
                ordenarConvertido: 0,

                respuesta:true,
            }
        },
        computed: {
            ...mapState(["permiso"]),
        },
        methods: {
            sortedArrayASC: function (nameAtributo) {
                switch (nameAtributo) {
                    case 1:
                        this.ordenarFecha = 1;

                        function compareFecha(a, b) {
                            if (a.date.toUpperCase() < b.date.toUpperCase())
                                return -1;
                            if (a.name.toUpperCase() > b.name.toUpperCase())
                                return 1;
                            return 0;
                        }

                        return this.list.sort(compareFecha);

                    case 2:
                        this.ordenarProveedor = 1;

                        function compareProveedor(a, b) {
                            if (a.supplierName.toUpperCase() < b.supplierName.toUpperCase())
                                return -1;
                            if (a.supplierName.toUpperCase() > b.supplierName.toUpperCase())
                                return 1;
                            return 0;
                        }

                        return this.list.sort(compareProveedor);

                    case 3:
                        this.ordenarImporte = 1;

                        function compareImporte(a, b) {

                            if (a.total < b.total)
                                return -1;
                            if (a.total > b.total)
                                return 1;
                            return 0;
                        }

                        return this.list.sort(compareImporte);

                    case 4:
                        this.ordenarBase = 1;

                        function compareBase(a, b) {

                            if (a.base < b.base)
                                return -1;
                            if (a.base > b.base)
                                return 1;
                            return 0;
                        }

                        return this.list.sort(compareBase);
                }
            },
            sortedArrayDESC: function (nameAtributo) {
                switch (nameAtributo) {
                    case 1:
                        this.ordenarFecha = 0;

                        function compareFecha(a, b) {
                            if (a.date.toUpperCase() > b.date.toUpperCase())
                                return -1;
                            if (a.name.toUpperCase() < b.name.toUpperCase())
                                return 1;
                            return 0;
                        }

                        return this.list.sort(compareFecha);

                    case 2:
                        this.ordenarProveedor = 0;

                        function compareProveedor(a, b) {
                            if (a.supplierName.toUpperCase() > b.supplierName.toUpperCase())
                                return -1;
                            if (a.supplierName.toUpperCase() < b.supplierName.toUpperCase())
                                return 1;
                            return 0;
                        }

                        return this.list.sort(compareProveedor);

                    case 3:
                        this.ordenarImporte = 0;

                        function compareImporte(a, b) {
                            if (a.total > b.total)
                                return -1;
                            if (a.total < b.total)
                                return 1;
                            return 0;
                        }

                        return this.list.sort(compareImporte);

                    case 4:
                        this.ordenarBase = 0;

                        function compareBase(a, b) {
                            if (a.base > b.base)
                                return -1;
                            if (a.base < b.base)
                                return 1;
                            return 0;
                        }

                        return this.list.sort(compareBase);
                }
            },

            urlExportPDFSinPrecio(id) {
                return this.$store.getters.apiUrl+"/orders/exportPedido/PDF/0?idPedido=" + id + "&idBusiness=" + this.idBusiness + "&jwt=" + this.$store.getters.jwt
            },
            urlExportExcelSinPrecio(id) {
                return this.$store.getters.apiUrl+"/orders/exportPedido/Excel/0?idPedido=" + id + "&idBusiness=" + this.idBusiness + "&jwt=" + this.$store.getters.jwt
            },

            urlExportExcelConPrecio(id) {
                return this.$store.getters.apiUrl+"/orders/exportPedido/Excel/1?idPedido=" + id + "&idBusiness=" + this.idBusiness + "&jwt=" + this.$store.getters.jwt
            },

            urlExportPDFConPrecio(id) {
                return this.$store.getters.apiUrl+"/orders/exportPedido/PDF/1?idPedido=" + id + "&idBusiness=" + this.idBusiness + "&jwt=" + this.$store.getters.jwt
            },

            agregarListaCorreo(obj) {
                this.emailSupplier = obj.supplierEmail;
                this.listBusinessesemail.push(this.idBusiness);
                // console.log(this.listBusinessesemail)
                obj.enviarCorreo = true;
                this.listEnviarCorreo.push(obj);
            },
            eliminarListaCorreo(obj, index) {
                obj.enviarCorreo = false;
                this.listBusinessesemail.splice(index,1);
                // console.log(this.listBusinessesemail)
                this.listEnviarCorreo.splice(index, 1)
            },

            enviarEmail() {
                if (this.emailSupplier !== "") {
                    var pedidos = this.listEnviarCorreo.map(function (x) {
                        return x.id;
                    });

                    var config = {
                        params: {
                            pedidos: pedidos,
                            emailPedido: this.emailSupplier,
                            idBusiness: this.idBusiness,
                            ListidBusiness: this.listBusinessesemail,
                            jwt: this.$store.getters.jwt,
                            precio: this.precio,
                            tipo: this.tipo
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt} 
                    };

                    let vm = this;
                    this.axios.get(this.$store.getters.apiUrl + "orders/sendEmailPedido", config)
                        .then(function (response) {
                            if (response.data == "OK") {
                                vm.closeModal();

                                vm.$notify({
                                    message: vm.$t("correoEnviadoCorrectamente"),
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });
                                vm.getPedidosNegocio();
                            } else {
                                swal({
                                    title: vm.$t("atencion"),
                                    text: response.data,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                            
                            vm.listBusinessesemail=[];
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                } else {
                    swal({
                        title: this.$i18n.t("atencion"),
                        text: this.$i18n.t("debeIntroducirUnEmailParaEnviarElPedido"),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                }
            },
            getBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                    .then(function (response) {

                        vm.listBusinesses = response.data.result;

                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        } else {
                            vm.idBusiness = response.data.result[0].id;
                        }

                        vm.getProveedores();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            getProveedores() {
                const controller = 'getSuppliersByBusiness';
                var config = {
                    params: {
                        pag: 0,
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                this.$store.dispatch("setIdBusiness", this.idBusiness);

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "suppliers/" + controller, config)
                    .then(function (response) {
                        if (response.data.response) {
                            if (response.data.result.suppliers.length === 0) {
                                let proveedor = {
                                    name:  vm.$i18n.t("todos"),
                                    id: 0
                                };

                                vm.listProveedores.push(proveedor);
                            }

                            for (let i = 0; i < response.data.result.suppliers.length; i++) {

                                if (i === 0) {
                                    let proveedor = {
                                        name:  vm.$i18n.t("todos"),
                                        id: 0
                                    };

                                    vm.listProveedores.push(proveedor);
                                }

                                let proveedorname = {
                                    name: response.data.result.suppliers[i].name,
                                    id: response.data.result.suppliers[i].id,
                                };

                                vm.listProveedores.push(proveedorname)
                            }

                            vm.getPedidosNegocio()
                        } else {
                            vm.respuesta=false;

                            swal({
                                title:  vm.$i18n.t("atencion"),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            getPedidosNegocio() {
                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title:  this.$i18n.t("ups"),
                        text:  this.$i18n.t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                } else {

                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title:  this.$i18n.t("ups"),
                            text:  this.$i18n.t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    } else {
                        this.loading = true;
                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);

                        var config = {
                            params: {
                                idBusiness: this.idBusiness,
                                idSupplier: this.idSupplier,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                tipo: this.tipo,
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.axios.get(this.$store.getters.apiUrl + "orders/getOrders", config)
                            .then(function (response) {
                                if (response.data.response) {
                                    vm.list = response.data.result;
                                    vm.respuesta=true;
                                } else {
                                    swal({
                                        title: `Error`,
                                        text: response.data.message,
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });

                                    vm.respuesta=false;
                                }

                                vm.loading = false;
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }
            },

            openModalEnviarCorreo() {
                this.$modal.show("modal-enviar-correo");
            },

            closeModal() {
                this.listEnviarCorreo = [];

                this.list.forEach(function (obj) {
                    obj.enviarCorreo = false;
                });

                this.listBusinessesemail= []
                this.$modal.hide("modal-enviar-correo");
                this.$modal.hide("modal-convertir-gasto");
            },

            modalConvertirGasto(index) {
                this.$modal.show("modal-convertir-gasto");
                this.indice = index;
            },

            convertirGasto(obj) {
                if (this.ref === "") {
                    swal({
                        title: this.$i18n.t("atencion"),
                        text: this.$i18n.t("laReferenciaEsObligatoria"),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                } else {
                    this.loadingConvertir = true;
                    var config = {
                        params: {
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };

                    var params = {
                        jwt: this.$store.getters.jwt,
                        idPedido: this.list[this.indice].id,
                        ref: this.ref,
                        idBusiness:this.idBusiness,
                        includedWarehouse: this.includedWarehouse,
                        tipo: this.tipoDocumento,
                    };

                    let vm = this;
                    let controller = "convertedOrder";
                    this.axios.post(this.$store.getters.apiUrl + 'orders/' + controller, params, config)
                        .then(function (response) {
                            if (response.data.response) {
                                vm.$notify({
                                    message: vm.$i18n.t("gastoVerificadoCorrectamente"),
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });

                                vm.getPedidosNegocio();
                                vm.closeModal();
                                vm.loadingConvertir = false;
                            } else {
                                vm.loadingConvertir = false;
                                swal({
                                    title: vm.$i18n.t("atencion"),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        }).catch(function (error) {
                        console.log(error);
                        vm.loadingConvertir = false;
                    });
                }
            },

            modaleliminar(obj) {
                swal({
                    title: this.$i18n.t("estasSeguroDeEliminarElPedido"),
                    text: this.$i18n.t("estaOperacionNoSePuedeDeshacer"),
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-danger btn-fill',
                    confirmButtonText: this.$i18n.t("siEliminarPedido"),
                    cancelButtonText: this.$i18n.t("cancelar"),
                    buttonsStyling: true
                }).then((result) => {
                    if (result.value) {
                        this.eliminarPedido(obj);
                    }
                })
            },
            eliminarPedido(g) {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                var params = {
                    jwt: this.$store.getters.jwt,
                    idPedido: g.id,
                };

                let vm = this;
                let controller = "deleteOrder";
                this.axios.post(this.$store.getters.apiUrl + 'orders/' + controller, params, config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.$notify({
                                message: vm.$i18n.t("pedidoEliminadoCorrectamente"),
                                icon: 'nc-icon nc-check-2',
                                timeout: 2000,
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'success'
                            });

                            vm.getPedidosNegocio();
                        } else {
                            swal({
                                title: vm.$i18n.t("atencion"),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    }).catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });

            },
            modificarPedido(obj) {
                this.$router.push({
                    name: 'pedido-proveedor',
                    params: {
                        'idBusiness': this.idBusiness,
                        'idPedido': obj.id, 'editar': 1
                    }
                })
            }
        }
    }
</script>
<style scoped>
    p {
        list-style: none;
        line-height: 36px;
        padding: 0 20px;
        margin: 0;
        font-size: 14px;
        color: #606266;
        cursor: pointer;
        outline: none;
    }

    .cursor {
        color: #428bca;
        cursor: pointer;
    }

    .cursor:hover {
        text-decoration: underline;
    }

    p:hover {

        background-color: #ECF5FF;
    }

    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .checkGenerarEntrada {
        font-size: 1.1em;
        font-weight: bold;
        cursor: pointer;
    }

    .btn-primary:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        background-color: #6c757d;
        border-color: #6c757d;
        pointer-events: none;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/PedidosProveedor/PedidosProveedor.vue